import React from 'react';

import { TerrainModel } from '../../../../../../viewer/elements/terrain-model';
import { useNonce } from '../../../../../hooks/use-nonce';
import { useAsset } from '../../../hooks/use-asset';
import { Asset } from '../../components/asset-blocks/asset';
import { TerrainModelBody } from './terrain-model-body';
import { TerrainModelHeader } from './terrain-model-header';

type Props = {
  asset: TerrainModel;
};

const TerrainModelAsset = (props: Props) => {
  const [_, refresh] = useNonce();

  useAsset(props.asset, {
    onAssetChanged: refresh,
  });

  React.useEffect(() => {
    props.asset.onVisibilityChanged = refresh;

    return () => {
      props.asset.onVisibilityChanged = undefined;
    };
  });

  return (
    <Asset asset={props.asset}>
      {{
        header: <TerrainModelHeader asset={props.asset} />,
        content: <TerrainModelBody asset={props.asset} />,
      }}
    </Asset>
  );
};

export { TerrainModelAsset, Props as TerrainModelAssetProps };
